module.exports = __webpack_public_path__ + "img/FullScreen.2ce1db3d.svg";